import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import contactBackground from '@/assets/images/home/contact-background.jpg'
import { Button } from '../Button'
import { Link } from 'react-router-dom'
export const ContactUs = () => {
  return (
    <>
      <section
        className={`relative min-h-[301px] w-full md:min-h-[399.5] lg:min-h-[498px]`}
      >
        <div className="absolute left-0 z-10 size-full bg-[rgba(0,0,0,0.5)]"></div>
        <div className="absolute left-0 z-0 size-full">
          <img src={contactBackground} className="size-full object-cover" />
        </div>
        <div
          className={`${pageXPadding} ${pageYPadding} relative z-20 flex min-h-[301px] items-center justify-center  md:min-h-[399.5] lg:min-h-[498px]`}
        >
          <div
            className={`${pageMaxWidth} mx-auto flex flex-col items-center gap-y-[12px] `}
          >
            <span className="text-center font-nunito text-[24px] font-bold  leading-[38.4px] md:text-[30px] md:leading-[48px] lg:text-[36px] lg:leading-[57.6px]">
              <span className="text-[#D4AF37]">{`Ready to transform your space? `}</span>
              <span className="text-[#F5F5F5]">{`Let’s bring your vision to life.`}</span>
            </span>
            <p className="text-center font-nunito text-[12px] leading-[19.2px] text-[#F5F5F5] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px] ">
              {`Schedule a consultation with our design experts to discuss your project goals, style preferences, and budget. We'll work closely with you to create a space that exceeds your expectations.`}
            </p>
            <Link to={'contact'}>
              <Button variant="secondary">Contact Us</Button>
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
